import { render, staticRenderFns } from "./JobView.vue?vue&type=template&id=01b6a1b1&scoped=true&"
import script from "./JobView.vue?vue&type=script&lang=js&"
export * from "./JobView.vue?vue&type=script&lang=js&"
import style0 from "./JobView.vue?vue&type=style&index=0&id=01b6a1b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6a1b1",
  null
  
)

export default component.exports